import React, { Component } from 'react';

import { List, ListItem } from 'material-ui/List';
import TextField from 'material-ui/TextField';
import FlatButton from 'material-ui/FlatButton';
import IconButton from 'material-ui/IconButton';
import Divider from 'material-ui/Divider';
import EditIcon from 'material-ui/svg-icons/image/edit';
import SaveIcon from 'material-ui/svg-icons/content/save';
import DeleteIcon from 'material-ui/svg-icons/action/delete';

import theme from '../../../muiTheme';
class SavedFilters extends Component {
  constructor(props) {
    super(props);
    this.nameInput = React.createRef();

    this.state = {
      name: '',
      error: false,
      renamingFilter: {
        originalName: null,
        newName: null,
        hasBeenModified: false,
        newNameError: false
      }
    };
  }

  handleFilterNameChanged = (e, name) => {
    if (this.isInvalidFilterName(name)) {
      this.setState({ name, error: true });
      return;
    }

    this.setState({ name, error: false });
  };

  handleFilterClick = (filter, name) => {
    this.props.onFilterSelected(filter, name);
  };

  handleBeginExistingFilterRename = filterName => {
    this.setState({
      renamingFilter: {
        originalName: filterName,
        newName: filterName,
        newNameError: false
      }
    });
  };

  handleExistingFilterNameChanged = (e, name) => {
    // short-circuit and mark as erroneous
    // if the filter name is invalid and also isn't the same as its original name
    if (
      this.isInvalidFilterName(name) &&
      name !== this.state.renamingFilter.originalName
    ) {
      this.setState({
        renamingFilter: {
          ...this.state.renamingFilter,
          newName: name,
          hasBeenModified: true,
          newNameError: true
        }
      });

      return;
    }

    this.setState({
      renamingFilter: {
        ...this.state.renamingFilter,
        newName: name,
        hasBeenModified: true,
        newNameError: false
      }
    });
  };

  handleSaveExistingFilterRename = () => {
    // short-circuit and mark as erroneous
    // if the filter name is invalid and also isn't the same as its original name
    if (
      this.isInvalidFilterName(this.state.renamingFilter.newName) &&
      this.state.renamingFilter.newName !==
        this.state.renamingFilter.originalName
    ) {
      this.setState({
        renamingFilter: {
          ...this.state.renamingFilter,
          newNameError: true
        }
      });

      return;
    }

    // no need to re-save a filter's name that hasn't changed from its original value
    if (
      this.state.renamingFilter.newName !==
      this.state.renamingFilter.originalName
    ) {
      this.props.onSaveExistingFilter(
        this.state.renamingFilter.originalName,
        this.state.renamingFilter.newName
      );
    }

    this.setState({
      renamingFilter: {
        originalName: null,
        newName: null,
        hasBeenModified: false,
        newNameError: false
      }
    });
  };

  handleDelete = filterName => {
    this.props.onFilterDeleted(filterName);

    // re-run the top-level, new filter name TextField change handler
    // in case any existing user input matches a filter that was just deleted
    // and needs to be re-evaluated to see if it is a valid or invalid value
    if (this.nameInput.current.props.value) {
      this.handleFilterNameChanged(null, this.nameInput.current.props.value);
    }

    // also re-run the existing filter TextField change hander
    // in case any existing filter name has been edited but is yet unsaved
    if (this.state.renamingFilter.hasBeenModified) {
      this.handleExistingFilterNameChanged(
        null,
        this.state.renamingFilter.newName
      );
    }
  };

  handleSaveFilter = () => {
    if (this.isInvalidFilterName(this.state.name)) {
      this.setState({ error: true });
      this.nameInput.current.focus();
      return;
    }

    this.props.onSaveNewFilter(this.state.name);
    this.setState({ name: '' });
  };

  getActionButtons(name) {
    // show the edit icon button (which is replaced by the save icon button if the user is renaming a filter's name)
    // and show the delete icon button
    return (
      <span>
        {name === this.state.renamingFilter.originalName &&
        this.state.renamingFilter.hasBeenModified ? (
          <IconButton
            onClick={() => this.handleSaveExistingFilterRename()}
            tooltip="Save"
            tooltipPosition="top-left"
            style={{ opacity: '0.5' }}
            hoveredStyle={{ opacity: '1' }}
          >
            <SaveIcon style={{ color: 'currentColor' }} />
          </IconButton>
        ) : (
          <IconButton
            onClick={() => this.handleBeginExistingFilterRename(name)}
            tooltip="Rename"
            tooltipPosition="top-left"
            style={{ opacity: '0.5' }}
            hoveredStyle={{ opacity: '1' }}
          >
            <EditIcon style={{ color: 'currentColor' }} />
          </IconButton>
        )}
        <IconButton
          onClick={() => this.handleDelete(name)}
          tooltip="Delete"
          tooltipPosition="top-left"
          style={{ opacity: '0.5' }}
          hoveredStyle={{ opacity: '1' }}
        >
          <DeleteIcon style={{ color: 'currentColor' }} />
        </IconButton>
      </span>
    );
  }

  isInvalidFilterName = name => {
    // a new filter name must not be an empty string and
    // it must be different than existing filter names
    return (
      !name ||
      Object.keys(this.props.filters).find(
        existingFilterName => existingFilterName === name
      )
    );
  };

  getFilterList = filters => {
    if (!filters || !Object.keys(filters).length) {
      return (
        <div style={styles.noFilterLabel}>
          You don't have any saved filters.
        </div>
      );
    }

    return Object.keys(filters)
      .reverse()
      .map(name => {
        const filter = filters[name];
        return (
          <ListItem
            key={name}
            primaryText={
              name === this.state.renamingFilter.originalName ? (
                <TextField // ref={this.nameInput}
                  name={`${name}-existingFilterName`}
                  value={this.state.renamingFilter.newName}
                  hintText="Filter name"
                  errorText={
                    this.state.renamingFilter.newNameError
                      ? 'A unique name is required'
                      : null
                  }
                  onChange={this.handleExistingFilterNameChanged}
                  style={styles.nameStyle}
                />
              ) : (
                <span title={name} style={styles.listItem}>
                  {name}
                </span>
              )
            }
            rightIconButton={this.getActionButtons(name)}
            onClick={() => {
              if (this.state.renamingFilter.originalName) {
                return;
              }
              this.handleFilterClick(filter, name);
            }}
          />
        );
      });
  };

  render() {
    return (
      <div style={styles.container}>
        <div style={styles.header}>
          <TextField
            ref={this.nameInput}
            name="newFilterName"
            value={this.state.name}
            hintText="New filter name"
            errorText={
              this.state.error ? 'A new, unique name is required' : null
            }
            onChange={this.handleFilterNameChanged}
            style={styles.nameStyle}
          />
          <FlatButton label="save" onClick={this.handleSaveFilter} />
        </div>
        <Divider />
        <List style={styles.list}>
          {this.getFilterList(this.props.filters)}
        </List>
      </div>
    );
  }
}

const styles = {
  container: {
    maxWidth: '600px'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    padding: '0.5rem 0.5rem 1rem 1rem'
  },
  list: {
    maxHeight: '350px',
    overflowY: 'auto'
  },
  listItem: {
    maxWidth: '450px',
    whiteSpace: 'nowrap',
    wordWrap: 'break-word',
    textOverflow: 'ellipsis',
    display: 'inline-block',
    overflow: 'hidden'
  },
  nameStyle: {
    flex: '1 0 75px'
  },
  noFilterLabel: {
    textAlign: 'center',
    padding: '2rem',
    color: theme.palette.secondaryTextColor,
    fontStyle: 'italic'
  }
};

export default SavedFilters;



// WEBPACK FOOTER //
// ./src/components/dispatches/ResourcePanels/SavedFilters.js